/**
 * Sources Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageMoneyAccountsComponent,
  AsyncManageMoneyTransactionsComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageMoneyAccountsComponent}
      />
      <Route
        path={`${match.url}/view-transactions`}
        component={AsyncManageMoneyTransactionsComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
